import axiosInstance from "../../../axiosInstance";
import apiEndpoints from "../../../api";

export const getUsersReq = (params = {}) => {
  return axiosInstance.get(apiEndpoints.GET_USERS_API, { params });
};

export const getAdminUsersReq = (params = {}) => {
  return axiosInstance.get(apiEndpoints.GET_ADMIN_USERS_API, { params });
};

// Error messages come back on err.message (the axios interceptor copies the
// server's message there). Validation 400s prefix it with "body: " / "params: " / "query: ".
export const userErrorMessage = (err) =>
  String(err?.message || 'Something went wrong').replace(/^(body|params|query):\s*/, '');

// PATCH /api/users/:id — partial update. Allowed keys: first_name, last_name,
// phone, password, is_active, is_super_admin. Anything else (e.g. email) is a 400.
export const updateUserReq = (id, body) => {
  return axiosInstance.patch(apiEndpoints.UPDATE_USER_API.replace(':id', id), body);
};

// PATCH /api/users/:id/status — { is_active: 0 | 1 } only. Society memberships
// are kept either way; deactivating also force-logs-out the user's sessions
// (data.revoked_sessions). 409 = already in that state.
export const setUserStatusReq = (id, isActive) => {
  return axiosInstance.patch(apiEndpoints.UPDATE_USER_STATUS_API.replace(':id', id), { is_active: isActive ? 1 : 0 });
};
